"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var transform = exports.transform = {
  type: "select",
  options: [{ label: "Capitalize", value: "capitalize" }, { label: "Uppercase", value: "uppercase" }, { label: "Lowercase", value: "lowercase" }]
};
var fontWeight = exports.fontWeight = {
  type: "select",
  options: [{ label: "Light", value: "300" }, { label: "Normal", value: "400" }, { label: "Medium", value: "500" }, { label: "Bold", value: "600" }]
};
var position = exports.position = {
  type: "select",
  options: [{ label: "Left", value: "left" }, { label: "Center", value: "center" }, { label: "Right", value: "right" }]
};

var contentAlign = exports.contentAlign = {
  type: "select",
  options: [{ label: "top", value: "flex-start" }, { label: "center", value: "center" }]
};